/**
 * MIRE data loaders — wired into `mireConfig.loaders`. `loadSummary` also feeds
 * the MireDataExplorer.
 */

import { loadSummaryTables, loadSystemLayers } from '#lib/common/loaders.js';
import { EMireModule, EProduct, type IMireSummaryData } from './interfaces';
import { MIRE_DATASET, buildSystemLayers } from './layers';

export const loadSystem = (apiKey: string) =>
	loadSystemLayers(apiKey, [MIRE_DATASET], buildSystemLayers);

// Expects location + Curves.
export const loadSummary = async (apiKey: string): Promise<IMireSummaryData> =>
	(await loadSummaryTables(
		apiKey,
		EProduct.MIRE,
		MIRE_DATASET,
		[EMireModule.Curves],
		2
	)) as unknown as IMireSummaryData;
